import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * A generic Guide component, look at
 * `satellite-guidance.js` && `SatelliteGuide.jsx`
 * for example data / usage
 *
 * consume something like:

  <Guide
    hasIntroSlide
    // Use this as guide won't track viewstate
    isTopElement={viewState.topElement === "Guide"}
    terria={terria}
    guideKey={SATELLITE_GUIDE_KEY}
    guideData={SatelliteGuideData}
    showGuide={viewState.showSatelliteGuidance}
    setShowGuide={bool => {
      viewState.showSatelliteGuidance = bool;
      // If we're closing for any reason, set prompted to true
      if (!bool) {
        viewState.toggleFeaturePrompt("satelliteGuidance", true, true);
      }
    }}
  />

 *
 */
import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Styles from "./guide.scss";

// import createReactClass from "create-react-class";
// // import knockout from "terriajs-cesium/Source/ThirdParty/knockout";

import Spacing from "../../Styled/Spacing";
import Text from "../../Styled/Text";
import { useTranslation } from "react-i18next";
import Button from "../../Styled/Button";
import Box from "../../Styled/Box";
import { Category, GuideAction } from "../../Core/AnalyticEvents/analyticEvents";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const GuideProgress = props => {
  // doesn't work for IE11
  // const countArray = Array.from(Array(props.maxStepCount).keys()).map(e => e++);

  const countArray = [];
  for (let i = 0; i < props.maxStepCount; i++) {
    countArray.push(i);
  }
  const currentStep = props.currentStep;
  return /*#__PURE__*/_jsx("div", {
    className: Styles.indicatorWrapper,
    children: countArray.map(count => {
      return /*#__PURE__*/_jsx("div", {
        className: classNames(Styles.indicator, {
          [Styles.indicatorEnabled]: count < currentStep
        })
      }, count);
    })
  });
};
GuideProgress.propTypes = {
  maxStepCount: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired
};
export const analyticsSetShowGuide = function (isOpen, index, guideKey, terria) {
  var _terria$analytics;
  let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    setCalledFromInside: false
  };
  const action = options.setCalledFromInside ? isOpen ? GuideAction.openInModal : GuideAction.closeInModal : isOpen ? GuideAction.open : GuideAction.close;
  (_terria$analytics = terria.analytics) === null || _terria$analytics === void 0 || _terria$analytics.logEvent(Category.guide, action, "At index: ".concat(index, ", Guide: ").concat(guideKey));
};
export const GuidePure = _ref => {
  let {
    terria,
    guideKey,
    hasIntroSlide = false,
    guideData,
    setShowGuide
  } = _ref;
  // Handle index locally for now (unless we do a "open guide at X point" in the future?)
  const [currentGuideIndex, setCurrentGuideIndex] = useState(0);
  const handlePrev = () => {
    var _terria$analytics2;
    const newIndex = currentGuideIndex - 1;
    (_terria$analytics2 = terria.analytics) === null || _terria$analytics2 === void 0 || _terria$analytics2.logEvent(Category.guide, GuideAction.navigatePrev, "New index: ".concat(newIndex, ", Guide: ").concat(guideKey));
    if (currentGuideIndex === 0) {
      handleSetShowGuide(false);
    } else {
      setCurrentGuideIndex(newIndex);
    }
  };
  const handleNext = () => {
    const newIndex = currentGuideIndex + 1;
    if (guideData[newIndex]) {
      var _terria$analytics3;
      (_terria$analytics3 = terria.analytics) === null || _terria$analytics3 === void 0 || _terria$analytics3.logEvent(Category.guide, GuideAction.navigateNext, "New index: ".concat(newIndex, ", Guide: ").concat(guideKey));
      setCurrentGuideIndex(newIndex);
    } else {
      handleSetShowGuide(false);
    }
  };
  const {
    t
  } = useTranslation();
  const handleSetShowGuide = bool => {
    analyticsSetShowGuide(bool, currentGuideIndex, guideKey, terria, {
      setCalledFromInside: true
    });
    setShowGuide(bool);
  };
  const currentGuide = guideData[currentGuideIndex] || {};
  const hidePrev = currentGuide.hidePrev || false;
  const hideNext = currentGuide.hideNext || false;
  const prevButtonText = currentGuide.prevText || t("general.prev");
  const nextButtonText = currentGuide.nextText || t("general.next");
  const maxStepCount = hasIntroSlide ? guideData.length - 1 : guideData.length;
  const currentStepCount = hasIntroSlide ? currentGuideIndex : currentGuideIndex + 1;
  return /*#__PURE__*/_jsxs(Box, {
    displayInlineBlock: true,
    children: [/*#__PURE__*/_jsx(Box, {
      fullWidth: true,
      styledHeight: "254px",
      backgroundImage: currentGuide.imageSrc
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 5
    }), /*#__PURE__*/_jsxs(Box, {
      paddedHorizontally: 1,
      displayInlineBlock: true,
      children: [/*#__PURE__*/_jsx(Text, {
        textDark: true,
        bold: true,
        subHeading: true,
        children: currentGuide.title
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 5
      }), /*#__PURE__*/_jsx(Box, {
        styledMinHeight: "100px",
        fullWidth: true,
        children: /*#__PURE__*/_jsx(Text, {
          textDark: true,
          medium: true,
          children: currentGuide.body
        })
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 7
      }), /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(_StyledBox, {
          children: /*#__PURE__*/_jsx(GuideProgress, {
            currentStep: currentStepCount,
            maxStepCount: maxStepCount
          })
        }), !hidePrev && /*#__PURE__*/_jsx(Button, {
          secondary: true,
          onClick: () => handlePrev(),
          styledMinWidth: "94px",
          children: prevButtonText
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 2
        }), /*#__PURE__*/_jsx(_StyledButton, {
          primary: true,
          onClick: () => handleNext(),
          styledMinWidth: "94px",
          $_css: hideNext && "visibility: hidden;",
          children: nextButtonText
        })]
      })]
    })]
  });
};
GuidePure.propTypes = {
  terria: PropTypes.object.isRequired,
  guideKey: PropTypes.string.isRequired,
  guideData: PropTypes.array.isRequired,
  setShowGuide: PropTypes.func.isRequired,
  guideClassName: PropTypes.string,
  hasIntroSlide: PropTypes.bool
};
export default GuidePure;
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n              margin-right: auto;\n            "])));
var _StyledButton = _styled2(Button).withConfig({
  displayName: "Guide___StyledButton",
  componentId: "sc-13y64vj-0"
})(["", ""], p => p.$_css);